import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogBody]',
  standalone: true
})
export class DialogBodyDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
